export const WardData = `
    id
    code
    name
    district
    isActive
    lastModifiedAt
    prefix
    city
`;
